import { Directive } from '@angular/core';

@Directive({
  selector: '[uiSideDrawerContent]'
})
export class SideDrawerContentDirective {}
